import React, { MouseEvent, ReactNode } from 'react';
import { Element } from './Tab.styles';
import { useTabContext } from '@/components/tab';

export interface TabProps {
  tabId: string;
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const Tab = ({ tabId, children, ...props }: TabProps) => {
  const { tabActive, toggle } = useTabContext();
  return (
    <Element
      role="tab"
      aria-controls={`tab-panel-${tabId}`}
      aria-selected={tabActive === tabId}
      id={`tab-${tabId}`}
      active={tabActive === tabId}
      onClick={(e) => toggle(tabId)}
      {...props}
    >
      {children}
    </Element>
  );
};

export default Tab;
